// extracted by mini-css-extract-plugin
export default {"root":"BackButton_root__eUvkQ","icon":"BackButton_icon__w-sxb"};